import { render, staticRenderFns } from "./HtmlContent.vue?vue&type=template&id=67e5884e&"
import script from "./HtmlContent.vue?vue&type=script&lang=js&"
export * from "./HtmlContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports